
import React, { useState } from 'react';
import { usePatientsData } from '@/hooks/usePatientsData';
import PatientsHeader from './PatientsHeader';
import PatientSearch from './PatientSearch';
import PatientForm from './PatientForm';
import PatientCard from './PatientCard';
import EmptyPatientsState from './EmptyPatientsState';
import type { Patient } from '@/types';

const Patients = () => {
  const { patients, setPatients, loading } = usePatientsData();
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);

  // Filter patients based on search
  const filteredPatients = patients.filter(patient => {
    const searchLower = searchTerm.toLowerCase();
    return (
      patient.first_name.toLowerCase().includes(searchLower) ||
      patient.last_name.toLowerCase().includes(searchLower) ||
      patient.medical_record_number?.toLowerCase().includes(searchLower) ||
      patient.phone?.toLowerCase().includes(searchLower)
    );
  });

  const handlePatientAdded = (newPatient: Patient) => {
    setPatients([newPatient, ...patients]);
  };

  if (loading) {
    return (
      <div className="p-4 flex justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="p-4 max-w-6xl mx-auto">
      <PatientsHeader onAddPatient={() => setShowAddForm(true)} />
      
      <PatientSearch 
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
      />

      {showAddForm && (
        <PatientForm
          onPatientAdded={handlePatientAdded}
          onClose={() => setShowAddForm(false)}
        />
      )}

      <div className="grid gap-4">
        {filteredPatients.length === 0 ? (
          <EmptyPatientsState searchTerm={searchTerm} />
        ) : (
          filteredPatients.map((patient) => (
            <PatientCard key={patient.id} patient={patient} />
          ))
        )}
      </div>
    </div>
  );
};

export default Patients;
